import React from 'react';


import { Disclosure } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'

const faqs = [
  {
    question: "Wie lange dauert die Einrichtung?",
    answer:
      "Meistens sind wir in 30–60 Minuten fertig, je nach Umfang der gewünschten Einstellungen.",
  },
  {
    question: "Kann ich meine Daten übertragen lassen?",
    answer:
      "Ja! Wir übertragen Ihre Kontakte, Fotos, Videos und mehr sicher auf Ihr neues Gerät.",
  },
  {
    question: "Welche Geräte unterstützen Sie?",
    answer:
      "Wir richten Smartphones und Tablets aller gängigen Marken wie Apple, Samsung, Huawei und mehr ein.",
  },

  // More questions...
]

export default function CenteredDark() {
  return (
    <div className="bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
        <div className="mx-auto max-w-4xl divide-y divide-white/10">
          <h2 className="text-2xl font-bold leading-10 tracking-tight text-white">Frequently asked questions</h2>
          <dl className="mt-10 space-y-6 divide-y divide-white/10">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6">
                {({ open }) => (
                  <>
                    <dt>
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-white">
                        <span className="text-base font-semibold leading-7">{faq.question}</span>
                        <span className="ml-6 flex h-7 items-center">
                          {open ? (
                            <MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
                          ) : (
                            <PlusSmallIcon className="h-6 w-6" aria-hidden="true" />
                          )}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <p className="text-base leading-7 text-gray-300">{faq.answer}</p>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
